interface NumberOptions {
    parser?(value: string): number;
}

export const ascertainNumber = (value: unknown, options?: NumberOptions): number => {
    const { parser: stringParser = parseInt } = options || {};

    switch (typeof value) {
        case 'number':
            return value;

        case 'string':
            return stringParser(value);

        default:
            return 0;
    }
};

/** A price in whole øre, so prices compare and subtract without float tails. */
export const toOre = (price: string | number): number => Math.round(Number(price) * 100);
